const childRoutes = (prop) => [
  {
    path: 'e-checklist-management',
    name: prop + '.e_checklist_management',
    meta: { auth: true },
    component: () => import('../pages/e-checklist-management/List.vue')
  },
  {
    path: 'online-admission-application',
    name: prop + '.online_admission_application',
    meta: { auth: true },
    component: () => import('../pages/online-admission-application/List.vue')
  },
  {
    path: 'dismissed-children',
    name: prop + '.dismissed_children',
    meta: { auth: true },
    component: () => import('../pages/dismissed-children/List.vue')
  },
  {
    path: 'released-children',
    name: prop + '.released_children',
    meta: { auth: true },
    component: () => import('../pages/released-children/List.vue')
  },
  {
    path: 'online-admission-application-entry',
    name: prop + '.online_admission_application_entry',
    meta: { auth: true },
    component: () => import('../pages/online-admission-application/Form.vue')
  },
  {
    path: 'circular-publication-management',
    name: prop + '.circular_publication_management',
    meta: { auth: true },
    component: () => import('../pages/circular-publication-management/List.vue')
  },
  {
    path: 'assign-to-school',
    name: prop + '.assign_to_school',
    meta: { auth: true },
    component: () => import('../pages/assign-to-school/List.vue')
  },
  {
    path: 'meeting-management',
    name: prop + '.meeting_management',
    meta: { auth: true },
    component: () => import('../pages/meeting-management/List.vue')
  },
  {
    path: 'e-notification',
    name: prop + '.e_notification',
    meta: { auth: true },
    component: () => import('../pages/e-notification/List.vue')
  },
  {
    path: 'school-transfer',
    name: prop + '.school_transfer',
    meta: { auth: true },
    component: () => import('../pages/school-transfer/List.vue')
  },
  {
    path: 'child-profile-management',
    name: prop + '.child_profile_management',
    meta: { auth: true },
    component: () => import('../pages/child-profile-management/List.vue')
  },
  {
    path: 'assign-to-rehabilitation',
    name: prop + '.assign_to_rehabilitation',
    meta: { auth: true },
    component: () => import('../pages/assign-to-rehabilitation/List.vue')
  }
]
const routes = [{
  path: '/child-service/child-admission-management',
  name: 'child_service.child_admission_management',
  component: () => import('@/layouts/ChildServiceLayout.vue'),
  meta: { auth: true },
  children: childRoutes('child_service.child_admission_management')
}]

export default routes
